import React, {useEffect} from "react";
import Footer from '../user/components/footer';
import Header from "../user/components/header";

const PurchasePayments = () => {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    }, []);

    return (
        <>
            <Header />
            <div className="sec_latestpd" style={{ marginTop: "150px" }}>
                <div className="container">
                    <div className="row mb-4">
                        <div className="col-md-12">
                            <h2 className="sec_title">PURCHASE & PAYMENTS</h2>
                            <hr />
                        </div>
                        <div className="col-md-12">
                            <h6><b>Purchasing</b></h6>
                            <p>You must be a Registered User in order to purchase the Art. Buyers are obligated to complete the sale transaction upon completion of the check-out process.</p>
                            <br />
                            <h6><b>Buyer Liable for Purchase Price, Freight and Transportation Fees, Custom Duties/Custom, Charges and Government Tax. </b></h6>
                            <p>Buyers are liable for the posted purchased price of the piece(s) of Art, any insurance, and Customs Duties. Charges, Packing, Freight and Shipping fees associated with the purchase, and any applicable taxes (collectively, the "Purchase Fees") except during the promotion period when <b>IndiGalleria</b> may offer free shipping from time to time. International customers must note that the cost of artwork in the cart does not cover Custom Clearance Fees and/or Custom Duties. If applicable, these charges would be collected by the courier partner at the time of delivery, or our courier partner might connect you before delivery, for these payments if applicable. These charges vary from country to country and are subject to change - hence we can't give you an estimate of the same. However, at the time of placing the Order, you may write to care@IndiGalleria.com to know if these charges may apply to your Order.</p>
                            <br />
                            <h6><b>Payments</b></h6>
                            <p><span style={{ textDecoration: 'line-through' }}>Payment for the Art may be made by International Customers by SWIFT Money Transfer (details available at checkout) &/or via PayPal (details available at checkout)</span>. Payment for the Art <b>for Indian customers</b> (delivery within India) by NEFT/RTGS/IMPS Transfer (details available at the time of checkout) &/or by Cheque Payment (details available at checkout/subject to clearance by Bank before shipping Art) as specified on the Site.  If payment is made by cheque, the piece(s) of Art will not be marked as sold until the cheque clears and payment is received by <b>IndiGalleria</b>. If the cheque is not received within 3 days of the purchase being actioned, the order will be deemed as cancelled.</p>

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default PurchasePayments;